module.exports = __webpack_public_path__ + "img/partOne-right.fe06b760.png";